import { createContext, useContext } from 'react';
import { ApolloError } from '@apollo/client';

import { SubscriptionPlanType } from '../../../../../common/interfaces/entities';
import { CreditProductPurchaseOrderForAfterPayment } from '../../types';

export type OpenModalOptions = {
  callback?: () => void;
  errorBannerProviderInitialValue?: ApolloError;
  premiumPlanTypeToPurchase: SubscriptionPlanType | undefined;
  onClose?: (
    creditProductPurchaseOrder?: CreditProductPurchaseOrderForAfterPayment
  ) => void;
  trackingSource: string;
};

type PremiumPlanPurchaseModalContext = {
  openPremiumPlanPurchaseModal: (options: OpenModalOptions) => boolean;
  isModalChunkLoadPending: boolean;
};

export const PremiumPlanPurchaseModalContext = createContext<
  PremiumPlanPurchaseModalContext | undefined
>(undefined);

export const usePremiumPlanPurchaseModal = () => {
  const context = useContext(PremiumPlanPurchaseModalContext);
  if (!context) {
    throw new Error(
      'usePremiumPlanPurchaseModal must be used within a PremiumPlanPurchaseModalProvider'
    );
  }
  return context;
};
